import React, {FC, PropsWithChildren} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {buildAddTeammateSettingsPath} from '../../../../../helpers/modelHelpers';
import {
  CellsEmptySetupActionsProps,
  StyledCellsEmptySetupActionsContentDiv,
  StyledCellsEmptySetupActionsSubTitleDiv,
  StyledCellsEmptySetupActionsTitleDiv,
  StyledCellsEmptySetupActionsWrapperDiv,
} from './cellsEmptyCommon';
import {CellsEmptySetupActionsButton} from './cellsEmptySetupActionsButton';
import {CellsEmptySetupActionsDismissButton} from './cellsEmptySetupActionsDismissButton';

/*
 * Component.
 */

export const CellsEmptyTeammatesSetupActions: FC<
  PropsWithChildren<PropsWithChildren<CellsEmptySetupActionsProps>>
> = (props) => (
  <StyledCellsEmptySetupActionsWrapperDiv>
    <StyledCellsEmptySetupActionsContentDiv>
      <StyledCellsEmptySetupActionsTitleDiv>
        <Trans id="cells-empty-cta-teammates-title">Add your teammates</Trans>
      </StyledCellsEmptySetupActionsTitleDiv>
      <StyledCellsEmptySetupActionsSubTitleDiv>
        <Trans id="cells-empty-cta-teammates-subtitle">
          Once your teammates have joined Front, the conversations assigned to them will appear in here.
        </Trans>
      </StyledCellsEmptySetupActionsSubTitleDiv>
      <CellsEmptySetupActionsButton
        buttonVariant={ButtonVariantsEnum.PRIMARY}
        interactionId="cells-empty-cta-teammates-invitebutton"
        title={<Trans id="cells-empty-cta-teammates-invitebutton">Invite teammates</Trans>}
        onClick={props.navigate(buildAddTeammateSettingsPath())}
      />
    </StyledCellsEmptySetupActionsContentDiv>
    <CellsEmptySetupActionsDismissButton
      interactionId="cells-empty-cta-teammates-dismissbutton"
      onClick={props.onDismissClick}
    />
  </StyledCellsEmptySetupActionsWrapperDiv>
);
